import { useState } from 'react'
import useFetch from '../hooks/useFetch'
import { apiWrapper, objectToQueryString } from './dataHookUtils'

export default () => {
  const fetch = useFetch()
  
  const [isLoading, setIsLoading] = useState()
  const [userAccount, setUserAccount] = useState()

  const fetchAccounts = async (searchVal, implementationsOnly) => {
    return apiWrapper({
      fetch,
      url: `accounts${objectToQueryString({ name: searchVal, implementationsOnly })}`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchAssociatedEvents = async (accountId) => {
    return apiWrapper({
      fetch,
      url: `accounts/account/associatedEvents${objectToQueryString({ accountId })}`,
      options: {
        method: 'GET'
      }
    });
  }

  const fetchUserAccount = async (userId) => {
    try {
      setIsLoading(true)
      const result = await apiWrapper({
        fetch,
        url: `accounts/user${objectToQueryString({ userId })}`,
        options: {
          method: 'GET'
        }
      });
      const singleResult = result?.[0]
      setUserAccount(singleResult)
      return singleResult
    } catch(e) {
      console.log(e)
      setUserAccount()
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    fetchAccounts,
    fetchAssociatedEvents,
    userAccount,
    fetchUserAccount
  }
}